import { formattedDatePtBr } from '@utils/dates/formattedDatePtBr'

import type { WeeklyBreakdownItemProps } from '@pages/Consumption/context/types'
import type { OcNfModalPurchaseOrdersProps } from '@pages/OcNfModal/context/types'
import type { PurchaseOrderDetailsFormProps } from './types'

export const setInitialFormValues = (
  mainData: WeeklyBreakdownItemProps | null,
  data: OcNfModalPurchaseOrdersProps | null
) => {
  const initialValues: PurchaseOrderDetailsFormProps = {
    filiCode: '',
    competenceDate: '',
    supplierCode: '',
    purchaseOrderNumber: '',
    origin: mainData?.origin || '',
    operation: `${mainData?.operation.code} - ${mainData?.operation.name}` || '',
    classification: mainData?.itemClassification || '',
    expectedDelivery: data?.expectedDate ? formattedDatePtBr(data.expectedDate) : '',
    itemsQuantity: data?.purchaseOrderItemCount?.toString() || '',
    totalValue: mainData?.totalValue.toFixed(2) || '',
    nfItensQuantity: data?.invoiceItemCount?.toString() || '',
    nfTotalValue: data?.invoiceTotalAmount?.toFixed(2) || '',
    deviationItensQuantity: data?.quantityDeviation?.toString() || '',
    deviationTotalValue: data?.totalAmountDeviation?.toFixed(2) || '',
    transferItensQuantity: data?.totalItemsTransferred?.toString() || '',
    transferTotalValue: data?.totalAmountTransferred?.toFixed(2) || '',
    observations: data?.observation || '',
    itemClassification: mainData?.itemClassification || ''
  }

  return initialValues
}
